module.exports = __webpack_public_path__ + "static/media/professoresdigitais-problema.4add6d9d.png";